import $ from "jquery";
const INACTIVITY_TIMEOUT_MS = 5000;

// Exported so other files can reuse the same animation frame throttling
export function throttleActivity(callback) {
    let isWaiting = false;
    return function (...args) {
        if (!isWaiting) {
            callback.apply(this, args);
            isWaiting = true;
            requestAnimationFrame(() => {
                isWaiting = false;
            });
        }
    };
}

export default class AutoPlayer {
    constructor(config) {
        this.streamUrl = config.streamUrl;
        this.playerId = config.playerId;
        this.wrapperId = config.wrapperId;
        this.$screenshot = config.$screenshot;
        this.$muteBtn = config.$muteBtn;
        this.height = config.height || '100%';

        this.injectDOM = config.injectDOM;
        this.onShow = config.onShow || (() => {});
        this.onComplete = config.onComplete || (() => {});
        this.onCleanup = config.onCleanup || (() => {});

        this.timer = null;
        this.playerSeen = false;
        this.playerReady = false;
        this.jwPlayerInstance = null;

        // throttleActivity is now correctly in scope
        this.handleActivity = throttleActivity(() => {
            if (!this.playerSeen) this.resetTimer();
        });
    }

    init() {
        if (!this.streamUrl || !this.$screenshot.length) return;

        const $wrapper = $('<div>', { id: this.wrapperId, class: 'autoplay-player-wrapper rounded-xxl' });
        const $player = $('<div>', { id: this.playerId, class: 'autoplay-player' });
        $wrapper.append($player);

        this.injectDOM($wrapper, this.$muteBtn);

        this.jwPlayerInstance = jwplayer(this.playerId).setup({
            file: this.streamUrl,
            autostart: false,
            mute: true,
            controls: false,
            width: '100%',
            height: this.height,
            stretching: 'uniform',
            aspectRatio: '16:9'
        });

        this.jwPlayerInstance.on('ready', () => { this.playerReady = true; });

        this.jwPlayerInstance.on('complete', () => {
            $(`#${this.wrapperId}`).fadeOut(300);
            this.$screenshot.animate({ opacity: 1 }, 300);
            this.$muteBtn.fadeOut(300);
            this.onComplete();
        });

        this.bindMuteToggle();

        $(document).on('mousemove scroll click keydown touchstart', this.handleActivity);
        this.resetTimer();
    }

    bindMuteToggle() {
        this.$muteBtn.on('click', () => {
            if (!this.jwPlayerInstance) return;
            const muted = this.jwPlayerInstance.getMute();
            this.jwPlayerInstance.setMute(!muted);
            this.$muteBtn.find('ion-icon').attr('name', muted ? 'volume-high' : 'volume-mute');
        });
    }

    showPlayer() {
        this.playerSeen = true;
        this.$screenshot.animate({ opacity: 0 }, 400);
        $(`#${this.wrapperId}`).fadeIn(400);

        setTimeout(() => {
            this.onShow();
            this.$muteBtn.css('display', 'flex').hide().fadeIn(400);
        }, 500);

        if (this.playerReady) {
            this.jwPlayerInstance.play();
        } else if (this.jwPlayerInstance) {
            this.jwPlayerInstance.one('ready', () => this.jwPlayerInstance.play());
        }
    }

    resetTimer() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.showPlayer(), INACTIVITY_TIMEOUT_MS);
    }

    stopAndHide() {
        clearTimeout(this.timer);
        $(document).off('mousemove scroll click keydown touchstart', this.handleActivity);

        if (this.jwPlayerInstance) {
            try { this.jwPlayerInstance.stop(); } catch (e) { /* Ignore */ }
        }

        $(`#${this.wrapperId}`).fadeOut(300);
        this.$screenshot.animate({ opacity: 1 }, 300);
        this.$muteBtn.fadeOut(300);
    }

    destroy() {
        this.stopAndHide();

        if (this.jwPlayerInstance) {
            try { this.jwPlayerInstance.remove(); } catch (e) { /* Ignore */ }
        }

        $(`#${this.wrapperId}`).remove();
        this.$muteBtn.remove();
        this.$screenshot.css('opacity', 1);

        this.onCleanup();
    }
}